module.exports = __webpack_public_path__ + "img/shrine-2-1440.be4d73cf.jpg";